import { render, staticRenderFns } from "./wish_matt_happy_birthday.vue?vue&type=template&id=7349ef90&scoped=true&"
import script from "./wish_matt_happy_birthday.vue?vue&type=script&lang=js&"
export * from "./wish_matt_happy_birthday.vue?vue&type=script&lang=js&"
import style0 from "./wish_matt_happy_birthday.vue?vue&type=style&index=0&id=7349ef90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7349ef90",
  null
  
)

export default component.exports